module.exports = __webpack_public_path__ + "img/card.1f36ad91.png";